import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import RowLayout from '../../components/Layouts/RowLayout';
import SMCButton from '../../components/Simple/SMCButton';
import LoadingContainer from '../../components/Page/LoadingContainer';

function FilterLayout({
    title='Filters',
    children,
    loading,
    clearAllAction
}) {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <RowLayout className={classes.header}>
                <span className={classes.headerTitle}>
                    {title}
                </span>
            </RowLayout>
            <LoadingContainer loading={loading}>
                {
                    clearAllAction &&
                    <RowLayout ltr className={classes.filter}>
                        <SMCButton icon="clear" variant="ghost" height={30} onClick={clearAllAction}>
                            Clear all
                        </SMCButton>
                    </RowLayout>
                }
                <div className={classes.body}>
                    {children}
                </div>
            </LoadingContainer>
            </div>
    )
}

const useStyles = makeStyles({
    root: {
        lineHeight: '24px',
        height: '100%'
    },
    header: {
        height: '35px',
        borderBottom: '1px solid #E0E4E8'
    },
    headerTitle: {
        paddingLeft: '20px',
    },
    filter: {
        height: '40px',
    },
    body: {
        padding: '5px 15px 15px 15px'
    }
})

FilterLayout.propTypes = {
    title: PropTypes.string,
    children: PropTypes.node
}

export default FilterLayout;